import { createSelector } from 'reselect';

import { StringStateDictionary } from '../reducers/utils/state-manager';

export type TwilioErrorLogState = {
  twilioErrorLogsById: { [twilioErrorLogId: number]: TwilioErrorLog };
  twilioErrorLogsStateByMessageSid: StringStateDictionary;
};
type State = { twilioErrorLogs: TwilioErrorLogState };

const twilioErrorLogsByIdSelector = (state: State) => state.twilioErrorLogs.twilioErrorLogsById;
const twilioErrorLogsSelector = createSelector(
  [twilioErrorLogsByIdSelector],
  (twilioErrorLogsById) => Object.values(twilioErrorLogsById),
);

export const twilioErrorLogForMessageSidSelector = createSelector(
  [twilioErrorLogsSelector, (_state: State, messageSid: string) => messageSid],
  (twilioErrorLogs, messageSid) => twilioErrorLogs.filter((l) => l.sid === messageSid),
);

const twilioErrorLogsStateByMessageSidSelector = (state: State) =>
  state.twilioErrorLogs.twilioErrorLogsStateByMessageSid;
export const twilioErrorLogsStateForMessageSidSelector = createSelector(
  [twilioErrorLogsStateByMessageSidSelector, (_state: State, messageSid: string) => messageSid],
  (twilioErrorLogsStateByMessageSid, messageSid) => twilioErrorLogsStateByMessageSid[messageSid],
);
